import Vue from 'vue'
import VueRouter from 'vue-router'
import Nav from '../views/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'nav',
    component: Nav
  },
  {
    path: '/provacy',
    name: 'Provacy',
    component: () => import('../views/provacy.vue')
  },
  {
    path: '/agree',
    name: 'Agree',
    component: () => import('../views/agree.vue')
  },
  {
    path: '/sdk',
    name: 'SDK',
    component: () => import('../views/sdk.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
